export const IS_PRODUCTION = process.env.NEXT_PUBLIC_SST_STAGE === 'prod';
export const IS_PREPROD = process.env.NEXT_PUBLIC_SST_STAGE === 'preprod';
export const IS_STAGING = process.env.NEXT_PUBLIC_SST_STAGE === 'staging';
export const IS_E2E_TEST = process.env.NEXT_PUBLIC_SST_STAGE === 'e2e';

const DEFAULT_AGENIUM_API_VERSION = '4';

const constants = {
    IS_PRODUCTION,
    IS_STAGING,
    IS_E2E_TEST,
    CUSTOMER_PORTAL_URL: process.env.NEXT_PUBLIC_CUSTOMER_PORTAL_URL,
    ATHENA_URL: process.env.NEXT_PUBLIC_ATHENA_URL,
    BUILD_COMMIT: process.env.NEXT_PUBLIC_BUILD_COMMIT,
    AGENIUM_URL: process.env.NEXT_PUBLIC_AGENIUM_URL,
    AGENIUM_VERSION: process.env.NEXT_PUBLIC_AGENIUM_VERSION,
    AGENIUM_API_VERSION: process.env.AGENIUM_API_VERSION ?? DEFAULT_AGENIUM_API_VERSION,
    NEXT_PUBLIC_AGENIUM_ENV: process.env.NEXT_PUBLIC_AGENIUM_ENV,
    NEXT_PUBLIC_AGENIUM_CLIENT_CODE: process.env.NEXT_PUBLIC_AGENIUM_CLIENT_CODE,
    NEXT_PUBLIC_AGENIUM_ACCOUNT_CODE: process.env.NEXT_PUBLIC_AGENIUM_ACCOUNT_CODE,
    AP_FORM_URL_PREFIX: process.env.NEXT_PUBLIC_AP_FORM_URL_PREFIX,
};

if (!constants.CUSTOMER_PORTAL_URL || !constants.ATHENA_URL) {
    throw new Error('CUSTOMER_PORTAL_URL and ATHENA_URL are required. Make sure you are running the app properly.');
}

export default constants;
